module.exports = __webpack_public_path__ + "img/dg.99935dab.svg";